import { observable, action, makeObservable, set } from 'mobx';

import { WarehouseType } from '../../shared/support/modelTypes';

export interface WarehouseFormStoreType {
	model: WarehouseType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude?: Array<any>;
	selectedItems: Array<any>;
	isFirstLoad: boolean;
	name: string;
	setValue(model: any, key: string, value: any): void;
}

class WarehouseFormStore implements WarehouseFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			selectedItems: observable,
			filterInclude: observable,
			isFirstLoad: observable,
			name: observable,
			setValue: action
		});
	}

	model = {
		deleted: false,
		displayName: null,
		elementType: 0,
		name: { ru: '' },
		parentId: null,
		priority: null,
		retailPriceTypeId: null,
		typeId: null,
		controlProductInStock: false
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	pluralName = 'warehouses';
	filterInclude = ['retailPriceType', 'type'];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	isFirstLoad = true;
	name = 'OrmWarehouse';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const warehouseFormStore = new WarehouseFormStore();

export default WarehouseFormStore;
